import * as yup from 'yup';

const schema = yup.object().shape({
  name: yup
    .string()
    .required()
    .trim(),
  audio: yup
    .mixed()
    .test('fileFormat', 'wav format only', value => {
      return value && value[0] && ['audio/wav'].includes(value[0].type);
    })
    .test('required', 'field is required', value => {
      return value && value[0];
    })
});

export default schema;
